import { render } from "./SignupProfile.vue?vue&type=template&id=e1c3b25c&ts=true"
import script from "./SignupProfile.vue?vue&type=script&lang=ts"
export * from "./SignupProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__